const icons = document.querySelectorAll('.compatibility .icon');
const categories = document.querySelectorAll('.compatibility .category > *:not(.category_name)');

class Compatibility {
    init() {
        this.toggle();
    }

    toggle() {
        icons.forEach( icon => {
            icon.addEventListener('mouseenter', (e) => {
                const name = e.target.dataset.name;

                this.activeCategories(name);
            })

            icon.addEventListener('mouseleave', (e) => {
                this.disactiveCategories();
            })
        })
    }

    activeCategories(name) {
        categories.forEach( category => {
            if (category.firstChild.classList.contains(name)) {
                this.active(category)
            }
        })
    }

    disactiveCategories() {
        categories.forEach(category => this.disactive(category))
    }

    active = (elem) => elem.classList.add('active');
    disactive = (elem) => elem.classList.remove('active');
}

export default new Compatibility();